import ContainedIcon from '@/components/ContainedIcon';
import InceptionIconBase from '@/components/Icons/InceptionIcon';
import { SharedEndpointModelFamily } from '@/graphql';

import {
  mapIconSizeToSize,
  mapModelFamilyToIconColor,
  mapModelFamilyToIconContainerColor,
} from '../utils';
import { SharedEndpointIconProps, SharedEndpointIconSize } from './types';

function InceptionIcon({ size }: SharedEndpointIconProps) {
  const [containerSize, iconSize] = mapIconSizeToSize(size);

  return (
    <ContainedIcon
      size={containerSize}
      color={mapModelFamilyToIconContainerColor(SharedEndpointModelFamily.Inception)}
      borderRadius={size === SharedEndpointIconSize.XSMALL ? 6 : 8}
    >
      <InceptionIconBase
        sx={{
          width: iconSize,
          height: iconSize,
          color: mapModelFamilyToIconColor(SharedEndpointModelFamily.Inception),
        }}
      />
    </ContainedIcon>
  );
}

export default InceptionIcon;
